import Loadable from '../../components/loadable';

const AddDashletDrawer = Loadable({
  loader: () => import('../../pages/account_profile/add_dashlet_drawer'),
});

angular.module('gym').value('AddDashletDrawer', AddDashletDrawer);
